import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  BILLING_CYCLE_LABELS,
  IBillingCycle,
} from 'src/app/services/products-subproject/products-subproject.service';

@Component({
    selector: 'app-billing-cycle-form',
    templateUrl: './billing-cycle-form.component.html',
    styleUrls: ['./billing-cycle-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BillingCycleFormComponent implements OnInit {
  @Input() billingCycles: IBillingCycle[] = [];
  @Input() set billingCycleId(value: number | null) {
    if (value) {
      this.selectedBillingCycle = this.billingCycles.find((cycle) => cycle.id === value) || null;
    } else {
      this.selectedBillingCycle = null;
    }
  }
  @Input() billingCycleControl!: FormControl;
  @Input() billingDayControl!: FormControl;

  public selectedBillingCycle: IBillingCycle | null = null;

  ngOnInit() {
    this.billingCycleControl.valueChanges.subscribe((cycleId: number) => {
      this.updateSelectedBillingCycle(cycleId);
    });

    if (this.billingCycleControl.value) {
      this.updateSelectedBillingCycle(this.billingCycleControl.value);
    }
  }

  private updateSelectedBillingCycle(cycleId: number): void {
    this.selectedBillingCycle = this.billingCycles.find((cycle) => cycle.id === cycleId) || null;
  }

  public getCycleLabel(type: string): string {
    const billingType = type as keyof typeof BILLING_CYCLE_LABELS;
    return BILLING_CYCLE_LABELS[billingType] || 'Unknown';
  }

  public getSelectedBillingCycle(): IBillingCycle | null {
    return this.selectedBillingCycle;
  }

  public onBillingCycleChange(selectedCycle: IBillingCycle): void {
    this.selectedBillingCycle = selectedCycle;
  }

  public cycleNeedsBillingDay(): boolean {
    if (this.selectedBillingCycle?.type === 'fixedBilling') return true;
    return false;
  }
}
